"use strict";
/**
 * @author Maxim Seredkin
 */

export default [
  "$uibModal",
  "ProjectRestService",
  function ($modal, ProjectRestService) {
    return {
      create: create,
      edit: edit,
      api: ProjectRestService,
    };

    function create(def) {
      return $modal.open({
        template: require("../../project/view/project-modal-create.html"),
        controller: "ProjectModalCreateController",
        size: "md",
        backdrop: false,
        resolve: {
          project: function () {
            return {};
          },
        },
      });
    }

    function edit(id) {
      const a = document.createElement("a");
      a.href = `/projects/${id}`;
      a.click();
    }
  },
];
